/*
 * Copyright (c) 2019 brightlamp
 */

import { axiosInit } from './axiosSetup';
import { store } from '@/store'

export default
{
    namespaced: true,
    state:
    {
        totalRecords: 0,
        mrns: [],
        latestPortalVer: 0
    },
    mutations:
    {
        SET_MRNS: (state, payload) =>
        {
            state.mrns = payload
        },
        SET_TOTAL_RECORDS: (state, payload) =>
        {
            state.totalRecords = payload
        },
        SET_LATEST_PORTAL_VER(state, payload)
        {
            state.latestPortalVer = payload
        },
        UPDATE_TEST_PENDING_VIEW_COUNT_LOCALLY: (state, payload) =>
        {
            // Update the patient test records
            for (let mrn of state.mrns)
            {
                if (mrn.mrn === payload)
                {
                    mrn.testsPendingViewCount = mrn.testsPendingViewCount > 0 ? mrn.testsPendingViewCount - 1 : 0;
                    break
                }
            }
            // Update the telehealth test records
            for (let testRequest of store.state.telehealth.testRequests)
            {
                if (testRequest.mrn === payload)
                {
                    testRequest.testsPendingViewCount = testRequest.testsPendingViewCount > 0 ? testRequest.testsPendingViewCount - 1 : 0
                }
            }
        }
    },
    actions:
    {
        GET_MRNS: async (context, payload) =>
        {
            const { page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
                const response = await axios.get('/patient-mrns-reflex-v2',
     {
                params:
                {
                    userOnly: payload.userOnly,
                    mrn: payload.search,
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage,
                    researchMode: payload.researchMode,
                    uId: payload.uId,
                    orgId: payload.orgId,
                    fullSearch: true
                }
            });
            getMrnsCommon(context, response)
        },
        GET_MRNS_WITH_SORT: async (context, payload) =>
        {
            const { sortBy, sortDesc, page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
            const response = await axios.get('/patient-mrns-reflex-v3',
     {
                params:
                {
                    userOnly: payload.userOnly,
                    searchValue: payload.searchValue,
                    sortValue: sortBy.length > 0 ? sortBy[0] : 'updatedAt',
                    sortOrder: sortDesc.length > 0 ? sortDesc[0] ? -1 : 1 : -1,
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage
                }
            });
            getMrnsCommon(context, response)
        },
        DELETE_MRN: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.delete(`/patient-info-reflex/${payload.mrn}`)
        },
        GET_MRN: async (context, payload) =>
        {
            const axios = await axiosInit();
            const response = await axios.get(`/patient-info-reflex/test-token/${payload.testToken}`);
            context.commit('SET_TOTAL_RECORDS', 1);
            const mrn = processMrn(response['data']);
            context.commit('SET_MRNS', [mrn])
        }
    }
}

function getMrnsCommon(context, response)
{
    context.commit('SET_TOTAL_RECORDS', response['headers']['max-count'] * 1);
    const mrns = response['data'];
    for (let mrn of mrns)
    {
        mrn = processMrn(mrn)
    }
    context.commit('SET_MRNS', mrns);
    context.commit('SET_LATEST_PORTAL_VER', parseInt(response['headers']['web-portal-ver']))
}

function processMrn(mrn)
{
    mrn.displayName = mrn.displayName != null ? mrn.displayName : 'N/A';
    mrn.name = mrn.name ? mrn.name : 'N/A';
    mrn.age = mrn.dob ? new Date().getFullYear() - new Date(mrn.dob).getFullYear() : 'N/A';
    const date = new Date(mrn.updatedAt);
    mrn.updatedAt = date.toLocaleString();
    return mrn
}